<template>

  <b-form-input
      :key="value"
      v-model="internalValue"
      :type="type"
      :step="step"
      :min="min"
      :max="max"
      :size="size"
      :disabled="disabled"
      :state="state"
      class="text-center custom-border"
      @blur="handleInput"
      @keydown.enter="handleInput"
  />
</template>

<script>
export default {
  name: "NumericInput",
  props: {
    id: String,
    value: Number,
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: Infinity
    },
    step: {
      type: Number,
      default: 1
    },
    size: {
      type: String,
      default: "md"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "number"
    },
    state: {
      type: [Boolean, null],
      default: null
    }
  },
  data() {
    return {
      internalValue: !isNaN(this.value)
          ? String(this.value)
          : String(this.min)
    };
  },
  watch: {
    value(newVal) {
      this.internalValue = String(newVal ?? this.min);
    }
  },
  methods: {
    emitChange() {
      let val = Number(this.internalValue);
      if (isNaN(val)) val = this.min;

      // ⚙️ Clamp entre min et max
      val = Math.min(Math.max(val, this.min), this.max);

      this.internalValue = String(val); // synchroniser visuellement
      this.$emit("input", val); // notifier le parent
    },
    handleInput() {
      this.emitChange();
    }
  }
};
</script>

<style scoped>
.b-form-input {
  text-align: center;
  border: 1px solid #d1d1d1;
}
</style>




<!--<template>-->
<!--  <b-input-group>-->
<!--    <b-input-group-prepend>-->
<!--      <b-button class="py-0 light-border-button" size="sm" @click="decrease">-->
<!--        <b-icon icon="dash" font-scale="1.6" />-->
<!--      </b-button>-->
<!--    </b-input-group-prepend>-->

<!--    <b-form-input-->
<!--      :key="value"-->
<!--      v-model="internalValue"-->
<!--      :type="type"-->
<!--      :step="step"-->
<!--      :min="min"-->
<!--      :max="max"-->
<!--      :size="size"-->
<!--      :disabled="disabled"-->
<!--      class="text-center custom-border"-->
<!--      -->
<!--      @blur="handleInput"-->
<!--      @keydown.enter="handleInput"-->
<!--    />-->

<!--    <b-input-group-append>-->
<!--      <b-button class="py-0 light-border-button" size="sm" @click="increase">-->
<!--        <b-icon icon="plus" font-scale="1.6" />-->
<!--      </b-button>-->
<!--    </b-input-group-append>-->
<!--  </b-input-group>-->
<!--</template>-->

<!--<script>-->
<!--export default {-->
<!--  name: "NumericInput",-->
<!--  props: {-->
<!--    id: String,-->
<!--    value: Number,-->
<!--    min: {-->
<!--      type: Number,-->
<!--      default: 0-->
<!--    },-->
<!--    max: {-->
<!--      type: Number,-->
<!--      default: Infinity-->
<!--    },-->
<!--    step: {-->
<!--      type: Number,-->
<!--      default: 1-->
<!--    },-->
<!--    size: {-->
<!--      type: String,-->
<!--      default: "md"-->
<!--    },-->
<!--    disabled: {-->
<!--      type: Boolean,-->
<!--      default: false-->
<!--    },-->
<!--    type: {-->
<!--      type: String,-->
<!--      default: "number"-->
<!--    }-->
<!--  },-->
<!--  data() {-->
<!--    return {-->
<!--      internalValue: !isNaN(this.value) ? String(this.value) : String(this.min)-->
<!--    };-->
<!--  },-->
<!--  watch: {-->
<!--    value(newVal) {-->
<!--      this.internalValue = String(newVal ?? this.min);-->
<!--    }-->
<!--  },-->
<!--  methods: {-->
<!--    emitChange() {-->
<!--      let val = Number(this.internalValue);-->
<!--      if (isNaN(val)) val = this.min;-->

<!--      // Clamp à min-max-->
<!--      val = Math.min(Math.max(val, this.min), this.max);-->

<!--      this.internalValue = String(val); // Synchroniser affichage-->

<!--      this.$emit("input", val); // Émettre la valeur bornée-->
<!--    },-->
<!--    increase() {-->
<!--      let current = Number(this.internalValue);-->
<!--      if (isNaN(current)) current = this.min;-->

<!--      const next = current + this.step;-->
<!--      if (next <= this.max) {-->
<!--        this.internalValue = String(next);-->
<!--        this.emitChange();-->
<!--      }-->
<!--    },-->
<!--    decrease() {-->
<!--      let current = Number(this.internalValue);-->
<!--      if (isNaN(current)) current = this.min;-->

<!--      const next = current - this.step;-->
<!--      if (next >= this.min) {-->
<!--        this.internalValue = String(next);-->
<!--        this.emitChange();-->
<!--      }-->
<!--    },-->
<!--    handleInput() {-->
<!--      this.emitChange(); // on délègue à emitChange-->
<!--    }-->
<!--  }-->
<!--};-->
<!--</script>-->

<!--<style scoped>-->
<!--.b-input-group {-->
<!--  display: flex;-->
<!--  flex-wrap: nowrap !important;-->
<!--  white-space: nowrap;-->
<!--  max-width: 220px;-->
<!--  width: 100%;-->
<!--}-->

<!--.b-form-input {-->
<!--  flex-grow: 1;-->
<!--  min-width: 0;-->
<!--  overflow: hidden;-->
<!--}-->

<!--.light-border-button {-->
<!--  flex-shrink: 0;-->
<!--  min-width: 38px;-->
<!--  border: 1px solid #d1d1d1 !important;-->
<!--  background-color: white !important;-->
<!--  color: #111111;-->
<!--}-->

<!--.light-border-button svg {-->
<!--  fill: #111111 !important;-->
<!--}-->

<!--.custom-border {-->
<!--  border: 1px solid #d1d1d1;-->
<!--}-->
<!--</style>-->
